import axios from "axios";
import { AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class GhabzModel extends BaseModel {
  RouteName = "Ghabz";
  protected AuthState: boolean = true;
  public async getAllWithPaginate(pageNumber: number, pageSize = 10) {
    try {
      return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/page?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    } catch (e: any) {
      const error = e as AxiosErr;
      if (axios.isCancel(error)) {
        throw error.message;
      }

      throw error.response?.data.message;
    }
  }
}
